import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Modulos } from 'src/app/core/modulos';
import { AcessoModuloResolver } from 'src/app/guards/acesso-modulo.resolve';
import { AuthGuard } from '../../guards/auth.guard';
import { CadastrarPublicoAlvoComponent } from './cadastrar-publico-alvo/cadastrar-publico-alvo.component';
import { PublicoAlvoComponent } from './publico-alvo.component';

const routes: Routes = [
  {path: 'publicosalvos/cadastrar', component: CadastrarPublicoAlvoComponent, canActivate: [AuthGuard],resolve: {perfilAcesso:AcessoModuloResolver}, data:{modulo:Modulos.PUBLICOS_ALVOS}},
  {path: 'publicosalvos', component: PublicoAlvoComponent, canActivate: [AuthGuard],resolve: {perfilAcesso:AcessoModuloResolver}, data:{modulo:Modulos.PUBLICOS_ALVOS}}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublicoAlvoRoutingModule { }
